export default {
  affiliates: [],
  affiliatesCount: 0
}
